import http from '@/http'

const PATH = '/reservation'

export default {
    /**
     * @param {{ number: string, params: {}}} data
     * @returns {Promise<void>}
     */
    async listActionsLogs ({number, params} ) {
        try {
            const response = await http.get(`${PATH}/numbers/${number}/actions-logs`, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
}
